import { RightOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { type ReactElement, useState } from 'react'

// eslint-disable-next-line sonarjs/prefer-read-only-props
export function ToggleText({ text, children }: { text: string; children: ReactElement }) {
  const [visible, setVisible] = useState(false)
  return (
    <>
      <Button
        icon={<RightOutlined rotate={visible ? 90 : 0} />}
        onClick={() => {
          setVisible((x) => !x)
        }}
        type="text"
      >
        {text}
      </Button>
      {visible && <div>{children}</div>}
    </>
  )
}
